import React from "react";

import { AppBar, Toolbar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import Logo from "./images/sofar-logo.svg";

const useStyles = makeStyles(theme => ({
  root: {
    background: "RGB(37, 42, 63)",
    flexGrow: 1,
    height: "6vh"
  },
  buttons: {
    marginLeft: "auto"
  },
  logo: {
    width: "100px",
    marginRight: theme.spacing(2)
  }
}));

const PublicNavbar = () => {
  const classes = useStyles();

  return (
    <AppBar className={classes.root} position="static">
      <Toolbar>
        <img
          className={classes.logo}
          src={Logo}
          alt="Sofar Ocean Technologies Logo"
        />
      </Toolbar>
    </AppBar>
  );
};

export default PublicNavbar;
